<template>
  <div>

    <xolas-table
       ref="permittable"
       table-ref="permittable"

       title="Permits"
       icon="fa fa-clipboard"

       :url="'/permits/site/' + rowData.id + (this.telcoId ? '/org/' + this.telcoId : '')"

       :fields="fields"

       :layer-component="'permit'"
       :layer-args="{ id: 'id' }">

      <!-- New-Permit button — XolasTable has no add-action prop (vuetable-2 legacy);
           render the action in the shared #actions slot like the other tables. -->
      <template v-if="isManager('project|maintenance|finance|property|admin')" #actions>
        <permit-action :row-data="rowData" :edit-mode="true" :read-only="readOnly" table-ref="permittable" />
      </template>

      <template #permit-controls="props">
        <permit-controls :row-data="props.rowData" />
      </template>

    </xolas-table>

<!--    <site-permit-to-work :row-data="rowData" /> -->

    <hr />

    <site-progress :row-data="rowData" />

  </div>

</template>


<script>
import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import {settings} from '@/components/Data'

import SiteProgress from '@/components/sites/SiteProgress'

import PermitAction from '@/components/actions/PermitAction'
import PermitDetails from '@/components/sites/permits/PermitDetails'
import PermitControls from '@/components/sites/permits/PermitControls'

import SitePermitToWork from '@/components/sites/permits/SitePermitToWork'
import XolasTable from '@/components/atoms/tables/XolasTable'

export default {

  mixins: [DateMixins, NumberMixins],


  components: {
    PermitControls,
    PermitAction,
    PermitDetails,
    SitePermitToWork,
    SiteProgress,
    XolasTable
  },


  props: {

    rowData: {
      type: Object,
      required: true
    },

    editMode: {
      type: Boolean,
      default: false
    },

    readOnly: {
      type: Boolean,
      default: false
    }


  },



  data () {

    return {

      telcoId: this.isTelco() ? Number(this.org().id) : null,

      // Per-column widths mirror the legacy vuetable content-based layout:
      // el-table's fixed table-layout distributes un-sized columns equally,
      // which bloats `#` and starves `Type`/controls (long permit-type names
      // wrap, inflating row height). minWidth gives el-table proportional hints
      // so the table matches the old widths (XOL-231 PR 5b).
      fields: [
        {
          name: 'permitType',
          title: 'Type',
          sortField: 'permitType',
          minWidth: '190'
        },
        {
          name: 'applied',
          title: 'Applied',
          callback: this.formatDate,
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '110'
        },
        {
          name: 'issued',
          title: 'Issued',
          callback: this.formatDate,
          titleClass: 'hidden-sm-and-down',
          dataClass: 'hidden-sm-and-down',
          minWidth: '110'
        },
        {
          name: 'expiry',
          title: 'Expiry',
          callback: this.formatDate,
          minWidth: '110'
        },
        {
          name: 'amount',
          title: 'Amount',
          callback: this.formatNumber,
          minWidth: '80'
        },
        {
          name: 'renewalPeriod',
          title: 'Period',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '80'
        },
        {
          name: 'ref1',
          title: settings.ref1Label,
          sortField: 'ref1',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '100'
        },
        {
          name: 'ref2',
          title: settings.ref2Label,
          sortField: 'ref2',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down',
          minWidth: '95'
        },
        {
          // Wide enough for the PermitControls row (Authority button + delete)
          // so the trash button doesn't overlap "Authority" (XOL-231 PR 5b).
          name: '__slot:permit-controls',
          title: '',
          width: '180'
        }
      ]
    }

  }

}

</script>
